module.exports = __webpack_public_path__ + "media/fonts/Objectivity-Medium-44e5524f18f5f94059b4a8969a203a61.otf";